"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenDataGuardConfig = void 0;
const flattenDataGuardConfig = (dataguardConfig) => dataguardConfig.reduce((acc, page, index) => {
    const inputs = page.dataGuardInputs.map((input) => (Object.assign({ pageNumber: index, pageTitle: page.title }, input)));
    acc.push(...inputs);
    return acc;
}, []);
exports.flattenDataGuardConfig = flattenDataGuardConfig;
